import {TranslationFunction} from "../../i18n/i18n";
import {CatalogFormatter} from "../../common/catalog/CatalogFormatter";
import {RobSubscriptionStatus} from "../../client/person/PersonApiClient";

export class RobSubscriptionStatusFormatter {
    static formatSubscriptionStatus(subscriptionStatus: RobSubscriptionStatus | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(subscriptionStatus, "robSubscriptionStatus", t);
    }
}
